import { PrivacyPolicy } from 'components/more-info-page/privacy-policy/PrivacyPolicy'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { PRIVACY_POLICY_VALIDATION } from 'services/validation/privacyPolicyValidation'
import { useFetch } from 'services/useFetch'
import { API_PRIVACY_POLICY } from 'services/apiPrivacyPolicy'
import { Alert } from 'avo-ui'
import { convertErrorMessage } from 'utils/utils'

const INITIAL_STATE = {
    title: null,
    description: null,
}

const FIELD_NAME_DETAIL = {
    title: 'Title',
    description: 'Description',
}

export const PrivacyPolicyContainer = () => {
    const [privacyPolicyDetail, setPrivacyPolicyDetail] = useState(INITIAL_STATE)
    const { fetching: getPrivacyPolicyDetail, isLoading } = useFetch(API_PRIVACY_POLICY.DETAIL)
    const { fetching: updatePrivacyPolicy, isLoading: isUpdating } = useFetch(API_PRIVACY_POLICY.UPDATE)
    const [errorMessage, setErrorMessage] = useState({})
    const { validateForm, errorForm } = useValidation({
        form: privacyPolicyDetail,
        schema: PRIVACY_POLICY_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value } = e
        setPrivacyPolicyDetail({ ...privacyPolicyDetail, [name]: value })
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            updatePrivacyPolicy(privacyPolicyDetail)
                .then(() => {
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'Privacy Policy Updated !',
                    })
                })
                .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
        })
    }

    useEffect(() => {
        getPrivacyPolicyDetail().then((response) => setPrivacyPolicyDetail({ ...response?.data }))
    }, [])

    const props = {
        privacyPolicyDetail,
        errorForm: { ...errorForm, ...errorMessage },
        onChangeForm,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <PrivacyPolicy {...props} />
}
